import { get, writable } from "svelte/store";

export const namePattern = /^[a-zA-Z0-9\_\-]+$/i;
export function validateNamePattern(n) {
  return namePattern.test(n);
}

export function deepcopy(o) {
  return JSON.parse(JSON.stringify(o));
}

export function getCascasedVal(o, k) {
  let key;
  if (k.constructor.name === "String") key = k.split("")
  else if (k.constructor.name === "Array") key = k;
  if (key) {
    if (key.length == 0) return undefined;
    else if (key.length == 1) return o[key[0]];
    else if (key.length > 1) return getCascasedVal(o[key[0]], key.slice(1))
  } else return undefined;
}

export function simpleNotUndefinedEq(a, b) {
  return a !== undefined && a == b;
}

export function isValidValud(d) {
  if (d == null) return false;
  if (d === undefined) return false;
  if (Number.isNaN(d)) return false;
  else return true;
}

export function isStore(d) {
  return (typeof d.set == 'function' && typeof d.update == 'function' && typeof d.subscribe == 'function');
}

export const systemTooltip = writable(undefined);
export function openSystemTooltip(event, value) {
  systemTooltip.set({
    x: event.clientX + 5,
    y: event.clientY + 5,
    content: value
  });
}
export function closeSystemTooltip() {
  systemTooltip.set({
    x: undefined,
    y: undefined,
    content: undefined
  });
}

export function datumMatch(o1, o2, o1_under_o2 = false) {
  if (o1 === o2) return true;
  else if (!o1 || !o2) return false;
  else if (o1.constructor.name === "Object" && o2.constructor.name === "Object") {
    if (o1_under_o2) {
      if (Object.keys(o1).length < Object.keys(o2).length) return false;
      let res = true;
      Object.keys(o2).forEach(key => {
        if (o1[key] !== o2[key]) res = false;
      });
      return res;
    } else {
      if (Object.keys(o1).length != Object.keys(o2).length) return false;
      let res = true;
      if (Object.keys(o1).length > 0) {
        Object.keys(o1).forEach(key => {
          if (o1[key] !== o2[key]) res = false;
        });
      } else {
        Object.keys(o2).forEach(key => {
          if (o1[key] !== o2[key]) res = false;
        });
      }
      return res;
    }
  }
}

export function squareDist(v1, v2) {
  return Math.sqrt(Math.pow(v1, 2) + Math.pow(v2, 2))
}

export const systemToast = writable(undefined);
export const justAppliedRecommendation = writable(undefined);
export function fireSystemToast(value) {
  systemToast.set(value);
}

export const contextMenu = writable(undefined);
export function openContextMenu(event, value) {
  contextMenu.set({
    x: event.clientX + 5,
    y: event.clientY + 5,
    content: value
  });
}
export function closeContextMenu() {
  contextMenu.set({
    x: undefined,
    y: undefined,
    content: undefined
  });
}